// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardInfo_card-info-container__gr612 {
  position: relative;
}
.CardInfo_card-info-container__item__39MY4 {
  width: 100%;
  background-color: var(--m-card-background-color);
  box-shadow: var(--m-box-shadow);
  padding: 16px;
  border-radius: var(--m-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-height: 97px;
}
.CardInfo_card-info-container__item--icon__yxolY {
  background-color: var(--m-background-subtle-primary);
  color: var(--m-primary);
  min-width: 2.2rem;
  width: 2.2rem;
  max-width: 2.2rem;
  min-height: 2.2rem;
  height: 2.2rem;
  max-height: 2.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CardInfo_card-info-container__item--icon__yxolY svg {
  font-size: 18px;
}
.CardInfo_card-info-container__item--icon--success__dFJ0F {
  background-color: var(--m-background-subtle-success);
  color: var(--m-success);
}
.CardInfo_card-info-container__item--icon--warning__LdXIQ {
  background-color: var(--m-background-subtle-warning);
  color: var(--m-warning);
}
.CardInfo_card-info-container__item--icon--danger__M6APf {
  background-color: var(--m-background-subtle-danger);
  color: var(--m-danger);
}
.CardInfo_card-info-container__item--title__bBi2l {
  font-size: var(--m-font-size-075);
  font-size: 13px;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--m-text-light);
  font-weight: 500;
}
.CardInfo_card-info-container__item__39MY4:not(.CardInfo_card-info-container__item--icon__yxolY) {
  margin-left: unset;
}
.CardInfo_card-info-container__item__content__pkpx0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}
.CardInfo_card-info-container__item__content--value__uzfeT {
  color: var(--m-text);
  font-weight: 600;
  font-size: var(--m-font-size-200);
  line-height: 23px;
}
.CardInfo_card-info-container__item__content--rate__aqfAW {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  font-size: 12px;
  color: #afbad6;
  font-weight: 500;
}
.CardInfo_card-info-container__item__content--rate__aqfAW svg {
  font-size: 18px;
}
.CardInfo_card-info-container__item__content--rate--positive__JGgME {
  color: var(--m-success);
}
.CardInfo_card-info-container__item__content--rate--negative__gLMNu {
  color: var(--m-danger);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/CardInfo/CardInfo.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,WAAA;EACA,gDAAA;EACA,+BAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACR;AACQ;EACI,oDAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACZ;AACY;EACI,eAAA;AAChB;AAEY;EACI,oDAAA;EACA,uBAAA;AAAhB;AAGY;EACI,oDAAA;EACA,uBAAA;AADhB;AAIY;EACI,mDAAA;EACA,sBAAA;AAFhB;AAMQ;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAJZ;AAOQ;EACI,kBAAA;AALZ;AAQQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AANZ;AAQY;EAEI,oBAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;AAPhB;AAUY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AARhB;AAUgB;EACI,eAAA;AARpB;AAWgB;EACI,uBAAA;AATpB;AAYgB;EACI,sBAAA;AAVpB","sourcesContent":[".card-info-container {\n    position: relative;\n\n    &__item {\n        width: 100%;\n        background-color: var(--m-card-background-color);\n        box-shadow: var(--m-box-shadow);\n        padding: 16px;\n        border-radius: var(--m-border-radius-md);\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        min-height: 97px;\n\n        &--icon {\n            background-color: var(--m-background-subtle-primary);\n            color: var(--m-primary);\n            min-width: 2.2rem;\n            width: 2.2rem;\n            max-width: 2.2rem;\n            min-height: 2.2rem;\n            height: 2.2rem;\n            max-height: 2.2rem;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            svg {\n                font-size: 18px;\n            }\n\n            &--success {\n                background-color: var(--m-background-subtle-success);\n                color: var(--m-success);\n            }\n\n            &--warning {\n                background-color: var(--m-background-subtle-warning);\n                color: var(--m-warning);\n            }\n\n            &--danger {\n                background-color: var(--m-background-subtle-danger);\n                color: var(--m-danger);\n            }\n        }\n\n        &--title {\n            font-size: var(--m-font-size-075);\n            font-size: 13px;\n            margin-left: 8px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            color: var(--m-text-light);\n            font-weight: 500;\n        }\n        \n        &:not(.card-info-container__item--icon) {\n            margin-left: unset;\n        }\n\n        &__content {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 5px;\n            flex-wrap: wrap;\n\n            &--value {\n                // color: #313877;\n                color: var(--m-text);\n                font-weight: 600;\n                font-size: var(--m-font-size-200);\n                line-height: 23px;\n            }\n\n            &--rate {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                margin-top: 5px;\n                font-size: 12px;\n                color: #afbad6;\n                font-weight: 500;\n\n                svg {\n                    font-size: 18px;\n                }\n\n                &--positive {\n                    color: var(--m-success);\n                }\n\n                &--negative {\n                    color: var(--m-danger);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-info-container": `CardInfo_card-info-container__gr612`,
	"card-info-container__item": `CardInfo_card-info-container__item__39MY4`,
	"card-info-container__item--icon": `CardInfo_card-info-container__item--icon__yxolY`,
	"card-info-container__item--icon--success": `CardInfo_card-info-container__item--icon--success__dFJ0F`,
	"card-info-container__item--icon--warning": `CardInfo_card-info-container__item--icon--warning__LdXIQ`,
	"card-info-container__item--icon--danger": `CardInfo_card-info-container__item--icon--danger__M6APf`,
	"card-info-container__item--title": `CardInfo_card-info-container__item--title__bBi2l`,
	"card-info-container__item__content": `CardInfo_card-info-container__item__content__pkpx0`,
	"card-info-container__item__content--value": `CardInfo_card-info-container__item__content--value__uzfeT`,
	"card-info-container__item__content--rate": `CardInfo_card-info-container__item__content--rate__aqfAW`,
	"card-info-container__item__content--rate--positive": `CardInfo_card-info-container__item__content--rate--positive__JGgME`,
	"card-info-container__item__content--rate--negative": `CardInfo_card-info-container__item__content--rate--negative__gLMNu`
};
export default ___CSS_LOADER_EXPORT___;
